import { MessageCircle } from "@/components/Icon";

const WhatsAppButton = () => (
  <a
    href="https://wa.me/31652526002"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-[#fff] rounded-full pl-4 pr-5 py-3 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
    aria-label="WhatsApp"
  >
    <MessageCircle className="w-5 h-5" />
    <span className="text-sm font-medium hidden sm:inline">Heb je een vraag?</span>
  </a>
);

export default WhatsAppButton;
